<script>
  export default {
    props: {
      itens: {
        type: Array,
        required: true,
      }
    },
    data() {
      return {
        item: this.camposItem(),
      }
    },
    methods: {
      camposItem() {
        return {
          descricao: '',
          quantidade: '',
          valor: '',
        }
      },
      remover(indice) {
        this.itens.splice(indice, 1);
      },
      adicionar() {
        this.itens.push(Object.assign(this.item, {}));
        
        this.item = this.camposItem();

        this.$validator.reset();
      },
      validar() {
        this.$validator
          .validateAll()
          .then(valido => {
            if (valido) {
              this.adicionar();
            }
          });
      },
      total(quantidade, valor) {
        return this.$options.filters.formatarNumero(quantidade, true) * this.$options.filters.formatarNumero(valor, true);
      },
    },
    computed: {
      descricaoContador() {
        let quantidadeCaracteres = this.item.descricao ?
          this.item.descricao.length : 0;

        return 1500 - quantidadeCaracteres;
      },
    }
  }
</script>

<template>
  <div>
    <table class="table table-bordered">
      <thead>
      <tr>
        <th>Observação</th>
        <th>Quantidade</th>
        <th>Valor(R$)</th>
        <th>Total(R$)</th>
        <th class="action"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(i, indice) in itens">
        <td class="white-space-pre">{{ i.descricao }}</td>
        <td class="text-right">{{ i.quantidade }}</td>
        <td class="text-right">{{ i.valor }}</td>
        <td class="text-right">{{ total(i.quantidade, i.valor) | formatarNumero }}</td>
        <td class="action">
          <button
            type="button"
            class="btn btn-xs btn-danger"
            @click="remover(indice)">
            <i class="fa fa-trash"></i>
          </button>
        </td>
      </tr>
      <tr v-if="itens.length === 0">
        <td colspan="4" class="text-center">Nenhum item adicionado.</td>
      </tr>
      </tbody>
    </table>

    <div class="row">
      <div class="col-lg-6">
        <div class="form-group required" :class="{'has-error': errors.has('descricao')}">
          <label class="control-label">Descrição ({{ descricaoContador }})</label>
          <!-- Alterar o model -->
          <textarea
            class="form-control"
            v-model="item.descricao"
            data-vv-name="descricao"
            data-vv-as="descrição"
            v-validate="'required'"
            maxlength="1500">
          </textarea>

          <p class="text-danger" v-show="errors.has('descricao')">{{ errors.first('descricao') }}</p>
        </div>
      </div>

      <div class="col-lg-3">
        <div class="form-group required" :class="{'has-error': errors.has('quantidade')}">
          <label class="control-label" for="quantidade">Quantidade</label>
          <!-- Alterar o model -->
          <input
            type="text"
            class="form-control text-right"
            id="quantidade"
            v-mascara="'moeda'"
            v-model="item.quantidade"
            data-vv-name="quantidade"
            data-vv-as="quantidade"
            v-validate="'required|not_zero'">

          <p class="text-danger" v-show="errors.has('quantidade')">{{ errors.first('quantidade') }}</p>
        </div>
      </div>

      <div class="col-lg-3">
        <div class="form-group required" :class="{'has-error': errors.has('valor')}">
          <label class="control-label" for="valor-item">Valor (R$)</label>
          <!-- Alterar o model -->
          <input
            type="text"
            class="form-control text-right"
            id="valor-item"
            v-mascara="'moeda'"
            v-model="item.valor"
            data-vv-name="valor"
            data-vv-as="valor"
            v-validate="'required|not_zero'">

          <p class="text-danger" v-show="errors.has('valor')">{{ errors.first('valor') }}</p>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-12">
        <button
          type="button"
          class="btn btn-success"
          @click="validar">
          <i class="fa fa-plus"></i> Adicionar item
        </button>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-faturamento/componentes/compartilhado/FormItens.vue